/**
 * Feature Flags Configuration
 * Sistema de controle de features com kill switch para produção
 */

interface FeatureFlags {
  ai_inline_editor: boolean;
}

/**
 * Feature flag para AI Inline Editor
 * Controla se o sistema de IA inline está ativo
 */
export const FEATURES: FeatureFlags = {
  ai_inline_editor: import.meta.env.VITE_FEATURE_AI_EDITOR === 'true' || false,
};

/**
 * Helper para verificar se uma feature está ativa
 */
export const isFeatureEnabled = (feature: keyof FeatureFlags): boolean => {
  return FEATURES[feature] ?? false;
};

/**
 * Log das features ativas (apenas em desenvolvimento)
 */
if (import.meta.env.DEV) {
  console.log('🚩 Feature Flags:', FEATURES);
}